export const ADMIN_MANAGER_GET = '[ADMIN MANAGER] GET';
export const ADMIN_MANAGER_GET_SUCCESS = '[ADMIN MANAGER] GET SUCCESS';
export const ADMIN_FAIL = '[ADMIN] FAIL';
export const ADMIN_MANAGER_CREATE = '[ADMIN MANAGER] CREATE';
export const ADMIN_MANAGER_UPDATE = '[ADMIN MANAGER] UPDATE';
export const ADMIN_MANAGER_UPDATE_SUCCESS = '[ADMIN MANAGER] UPDATE SUCCESS';
export const ADMIN_EXCLUDE_STRING_GET = '[ADMIN EXCLUDE STRING] GET';
export const ADMIN_EXCLUDE_STRING_GET_SUCCESS = '[ADMIN EXCLUDE STRING] GET SUCCESS'
export const ADMIN_EXCLUDE_STRING_SAVE = '[ADMIN EXCLUDE STRING] SAVE'
export const ADMIN_EXCLUDE_STRING_DELETE = '[ADMIN EXCLUDE STRING] DELETE'